import * as tslib_1 from "tslib";
import { ErrorEvent } from "./ErrorEvent";
var IOErrorEvent = (function (_super) {
    tslib_1.__extends(IOErrorEvent, _super);
    function IOErrorEvent() {
        return _super.apply(this, arguments) || this;
    }
    IOErrorEvent.prototype.clone = function () {
        console.log("clone not implemented yet in flash/IOErrorEvent");
        return null;
    };
    IOErrorEvent.prototype.toString = function () {
        console.log("toString not implemented yet in flash/IOErrorEvent");
        return "";
    };
    return IOErrorEvent;
}(ErrorEvent));
export { IOErrorEvent };
IOErrorEvent.IO_ERROR = "ioError";
IOErrorEvent.DISK_ERROR = "diskError";
IOErrorEvent.NETWORK_ERROR = "networkError";
IOErrorEvent.VERIFY_ERROR = "verifyError";
